import { GiftCardItem } from './GiftCardItem';
import { PaymentType } from './PaymentType';

export class LastOrder {
    orderId: string;
    basketId: string;
    isFavorite: boolean;
    faveId?: number;
    giftCardLastOrder: Array<GiftCardItem>;
    paymentType?: PaymentType;
    userToken: string | null;
}
